module.exports = __webpack_public_path__ + "img/isle_project_1.5b3e8c43.gif";